"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* istanbul ignore file */
tslib_1.__exportStar(require("./legacy"), exports);
//# sourceMappingURL=index.js.map